import 'babel-core/register';
import '@babel/polyfill';
import './pendingAxiosRequest';

import 'react';
import 'redux';
import 'rxjs';
import 'immutable';
import 'react-redux';
import 'react-dom';
import 'moment';
import 'moment-timezone';
import 'core-js';
import '@material-ui/core';
import 'lodash';
import 'react-select';
import 'searchkit';
import 'axios';
